<form #theForm="ngForm" class="js-validate" novalidate="novalidate">

<div class="modal-header">
  <button class="btn btn-secondary mr-2" type="button" (click)="cancel()">Cancel</button>
<h4>Purchase Addons <span *ngIf="initialized"> {{actualPrice| currency: existingRegistration.package.currencyCode:'symbol'}}</span></h4>
  <div>
    <button class="btn btn-success" type="button" (click)="next(ccContent)">
      <span>Next</span>
    </button>
  </div>
</div>
<div class="row" *ngIf="!initialized">
  <div class="col-md-12 text-center">
    <h4>Loading Registration</h4>
    <page-load-header></page-load-header>
  </div>
</div>
<div *ngIf="initialized" class="pl-3 pr-3 pt-0 pb-3 vh-100">
  <div class="row">

    <div class="col-md-12 mb-3">


      <div class="form-row">
        <div *ngIf="existingRegistration.package.ceUsAreExtra && !existingRegistration.paidForCEUs" class="col-md-6 mb-2">
          <label for="uname1"><strong> Would you like to add CEUs to your registration?</strong></label>
          <select class="form-control" (change)="calculatePrice()" [(ngModel)]="model.purchaseCEUs" required name="purchaseCEUs">
            <option [ngValue]="null">Please choose....</option>
            <option [ngValue]="true">Yes (+{{ (existingRegistration.memberRate ? existingRegistration.package.ceuPrice : existingRegistration.package.ceuNonMemberPrice == null ? existingRegistration.package.ceuPrice : existingRegistration.package.ceuNonMemberPrice) | currency: existingRegistration.package.currencyCode:'symbol' }})</option>
            <option [ngValue]="false">No</option>
          </select>
          <div class="invalid-message">
            <div>Please indicate if you want CEUs.</div>
          </div>
        </div>
      </div>

      <div class="d-block">
        <strong>Would you like to add any add-ons to your registration?</strong>
      </div>
      <!-- Checkbox Switch -->
      <ng-container *ngFor="let addon of addons; let i = index">
        <div class="custom-control custom-switch">
          <input type="checkbox" class="custom-control-input" (change)="calculatePrice()" [(ngModel)]="addon.selected" name="addons{{ i }}" id="customSwitch{{ i }}"/>
          <label class="custom-control-label" for="customSwitch{{ i }}">
                <span class="d-block"
                >{{ addon.name }}
                  <span *ngIf="addon.price > 0">(+{{ addon.price | currency: packageData.currencyCode }})</span><span *ngIf="addon.price == 0">(FREE)</span></span
                >
            <small class="d-block text-muted">{{ addon.description }}</small>
          </label>
        </div>
        <!-- End Checkbox Switch -->

        <hr class="my-2"/>
      </ng-container>
    </div>
  </div>
  <div *ngIf="eventAddons.length > 0" class="form-row">
    <div class="col-md-12 mb-3">
      <div class="d-block"><strong>Would you like to add any workshops to your registration?</strong></div>

      <!-- Checkbox Switch -->
      <ng-container *ngFor="let addon of eventAddons; let i = index">
        <div class="custom-control custom-switch">
          <input type="checkbox" class="custom-control-input" (change)="calculatePrice()" [(ngModel)]="addon.selected" name="eventAddons{{ i }}" id="customEventSwitch{{ i }}" />
          <label class="custom-control-label" for="customEventSwitch{{ i }}">
            <span class="d-block">{{ addon.formattedStartTime }} {{ addon.title }} (+{{ addon.price | currency: existingRegistration.package.currencyCode:'symbol' }})</span>
            <small class="d-block text-muted">{{ addon.instructor.fullNameWithCredentials }}</small>
          </label>
        </div>
        <!-- End Checkbox Switch -->

        <hr class="my-2" />
      </ng-container>
    </div>
  </div>
</div>
  <ng-template #ccContent let-modal>
    <div *ngIf="initialized" class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Complete Purchase {{actualPrice| currency: existingRegistration.package.currencyCode:'symbol'}}</h5>
      </div>
        <div class="modal-body">
          <div *ngIf="errorMessage" class="alert alert-danger" role="alert">
            {{ errorMessage }}
          </div>
          <div class="form-row mb-2">
            <div class="col-md-9">
              <input type="text" class="form-control" placeholder="Card Number" [(ngModel)]="cardNumber" required name="cardNumber" aria-label="Username" aria-describedby="basic-addon1" />
              <div class="invalid-message">
                <div>Must be a valid card number</div>
              </div>
            </div>
            <div class="col-md-3 mt-auto mb-auto">
              <img class="img-fluid" src="/assets/visa-mastercard-amex_0.png" />
            </div>
          </div>
          <div class="form-row">
            <div class="col">
              <select class="form-control" [(ngModel)]="expMo" required name="expMo">
                <option value="1">01 - January</option>
                <option value="2">02 - February</option>
                <option value="3">03 - March</option>
                <option value="4">04 - April</option>
                <option value="5">05 - May</option>
                <option value="6">06 - June</option>
                <option value="7">07 - July</option>
                <option value="8">08 - August</option>
                <option value="9">09 - September</option>
                <option value="10">10 - October</option>
                <option value="11">11 - November</option>
                <option value="12">12 - December</option>
              </select>
              <div class="invalid-message">
                <div>Must be a valid month</div>
              </div>
            </div>
            <div class="col">
              <select class="form-control" [(ngModel)]="expYr" required name="expYr">
                <option value="2024">2024</option>
                <option value="2025">2025</option>
                <option value="2026">2026</option>
                <option value="2027">2027</option>
                <option value="2028">2028</option>
                <option value="2029">2029</option>
                <option value="2030">2030</option>
                <option value="2031">2031</option>
                <option value="2032">2032</option>
                <option value="2033">2033</option>
                <option value="2034">2034</option>
                <option value="2034">2035</option>
                <option value="2034">2036</option>
                <option value="2034">2037</option>
                <option value="2034">2038</option>
                <option value="2034">2039</option>
                <option value="2034">2040</option>
                <option value="2034">2041</option>
              </select>
              <div class="invalid-message">
                <div>Must be a valid year</div>
              </div>
            </div>
            <div class="col">
              <input type="text" class="form-control" placeholder="cvv"  [(ngModel)]="cvv" name="cvv" required />
              <div class="invalid-message">
                <div>CVV is required</div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <div class="col text-left pl-0">
            <button type="button" class="btn btn-sm btn-secondary"  (click)="modal.dismiss()">Cancel</button>
          </div>
          <div class="col text-right pr-0">
            <button type="button"  class="btn btn-sm btn-admin-primary" (click)="purchasePackageClicked(modal)" [promiseBtn]="submitComplete">Save</button>
          </div>
        </div>

    </div>

  </ng-template>
</form>
